module.exports = __webpack_public_path__ + "img/sarissophoroi_ua.5f0bd83b.webp";